import magazineUrls from './magazine.urls';
import { getData, rejectPromise } from '@project/services/utils';
import { authNetworkService } from '@project/services';

const getMagazines = (page?: number, per?: number) => {
  const url = magazineUrls.getMagazinesUrl(page, per);

  return authNetworkService.get(url).then(getData).catch(rejectPromise);
};

const getMagazineContent = (id: number): Promise<Blob> => {
  const url = magazineUrls.getContentUrl(id);

  return authNetworkService.get(url, { responseType: 'blob' }).then(getData).catch(rejectPromise);
};

const getMagazineSubscription = () => {
  const url = magazineUrls.getSubscriptionUrl();

  return authNetworkService.get(url).then(getData).catch(rejectPromise);
};

const subscribe = () => {
  const url = magazineUrls.subscribeUrl();

  return authNetworkService.post(url, {}).then(getData).catch(rejectPromise);
};

const confirmSubscription = () => {
  const url = magazineUrls.confirmSubscriptionUrl();

  return authNetworkService.post(url, {}).then(getData).catch(rejectPromise);
};

const cancelSubscription = (id: string) => {
  const url = magazineUrls.cancelSubscriptionUrl(id);

  return authNetworkService.delete(url).then(getData).catch(rejectPromise);
};

export default {
  getMagazines,
  getMagazineContent,
  getMagazineSubscription,
  subscribe,
  confirmSubscription,
  cancelSubscription,
};
